import {
  IconCar4,
  IconHomeHouse,
  IconShieldProtected4,
  IconMoneyBanknoteHand,
} from '@creditas-ui/react';
import { CardHeader, Card } from '@/components/Card';
import i18n from '@/i18n';
import { Title, CardContent } from './DiscoverySection.style';

type CardOnCLickProp = {
  onClick: () => void;
};

type CardHomeEquityProps = CardOnCLickProp;

const CardHomeEquity = ({ onClick }: CardHomeEquityProps): JSX.Element => (
  <Card
    shadow
    gridColumn="auto"
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    onClick={onClick}
  >
    <CardHeader>
      <IconHomeHouse size={30} strokeWidth={0.8} />
    </CardHeader>
    <CardContent flexDirection="column" paddingRight={{ _: '40px', '5xl': '24px' }} marginTop="0">
      <Title color="neutral.90" variant="bodyLgMedium">
        {i18n.t('discoverySection:cards.home_loan.title')}
      </Title>
    </CardContent>
  </Card>
);

type CardAutoEquityProps = CardOnCLickProp;

const CardAutoEquity = ({ onClick }: CardAutoEquityProps): JSX.Element => (
  <Card
    shadow
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    onClick={onClick}
  >
    <CardHeader>
      <IconCar4 size={30} strokeWidth={0.8} />
    </CardHeader>
    <CardContent flexDirection="column" marginTop="0">
      <Title color="neutral.90" variant="bodyLgMedium">
        {i18n.t('discoverySection:cards.car_loan.title')}
      </Title>
    </CardContent>
  </Card>
);

type CardInsuranceProps = CardOnCLickProp;

const CardInsurance = ({ onClick }: CardInsuranceProps): JSX.Element => (
  <Card
    shadow
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    onClick={onClick}
  >
    <CardHeader>
      <IconShieldProtected4 size={30} strokeWidth={0.8} />
    </CardHeader>
    <CardContent flexDirection="column" marginTop="0">
      <Title color="neutral.90" variant="bodyLgMedium">
        {i18n.t('discoverySection:cards.insurance.title')}
      </Title>
    </CardContent>
  </Card>
);

type CardPayrollLoanProps = CardOnCLickProp;

const CardPayrollLoan = ({ onClick }: CardPayrollLoanProps): JSX.Element => (
  <Card
    shadow
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    onClick={onClick}
  >
    <CardHeader>
      <IconMoneyBanknoteHand size={30} strokeWidth={0.8} />
    </CardHeader>
    <CardContent flexDirection="column" marginTop="0">
      <Title color="neutral.90" variant="bodyLgMedium">
        {i18n.t('discoverySection:cards.payroll_loan.title')}
      </Title>
    </CardContent>
  </Card>
);

export { CardHomeEquity, CardAutoEquity, CardInsurance, CardPayrollLoan };
